/**
 * Per-zone card: header (zone label + cap count) + the cell grid.
 * Lays out the cells in the zone-specific grid (e.g. infrastructure
 * is rendered 8-column on the bottom band; governance is 2-column).
 */
import { CapabilityCellTile } from "twin/capmap/CapabilityCellTile";
import type { CapabilityState } from "twin/capmap/stateMap";
import type { CapabilityCell, CapabilityZone } from "shared/api/types";

export interface CapabilityZoneCardProps {
  zone: CapabilityZone;
  cells: CapabilityCell[];
  states: Map<string, CapabilityState>;
  selectedId: string | null;
  litSet: Set<string> | null;
  lens: "map" | "mvb" | "live";
  originId: string | null;
  onSelect: (id: string, anchor: HTMLDivElement) => void;
}

export function CapabilityZoneCard({
  zone,
  cells,
  states,
  selectedId,
  litSet,
  lens,
  originId,
  onSelect,
}: CapabilityZoneCardProps): JSX.Element {
  return (
    <div
      data-testid="capmap-zone"
      data-zone={zone.id}
      data-band={zone.band}
      className={`capmap-zone capmap-band-${zone.band} capmap-z-${zone.id}`}
    >
      <div className="capmap-zh">
        {zone.label}
        <span className="capmap-zct">{cells.length}</span>
      </div>
      <div className="capmap-cells">
        {cells.map((cap) => {
          const isMvbLensDimmed = lens === "mvb" && !cap.mvb_flag;
          const isOutsideLitSet = litSet ? !litSet.has(cap.id) : false;
          const dim = isMvbLensDimmed || isOutsideLitSet;
          return (
            <CapabilityCellTile
              key={cap.id}
              cap={cap}
              state={states.get(cap.id) ?? "stable"}
              selected={selectedId === cap.id}
              lit={litSet ? litSet.has(cap.id) : false}
              dim={dim}
              isOrigin={cap.id === originId}
              onSelect={onSelect}
            />
          );
        })}
      </div>
    </div>
  );
}
